import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

import instagram_square from '../../../assets/img/instagram-square.png';

class Entertainment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Entertainment </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                      Entertainment is usually associated with immersion, escape and bringing impossible to life; 
                      thus making us forget about the reality. Virtual reality offers precisely the same, 
                      but with a massive technological incentive, stimulating environment and graphic that 
                      often look better than the truth.
                      <br></br>
                      So put aside what you already know and prepare to discover new ways of entertainment 
                      and virtual reality. From expensive amusement parks to virtual reality cinemas and adult industry.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Virtual Reality Cinemas</b>
                    <br></br>
                      If there is a new technology coming out, cinemas and film industry are always 
                      the first ones to try it out. And it was not any different with virtual reality.
                      <br></br>
                      As it is, cinemas already carry an immersive atmosphere around them, wanting 
                      the audience to get lost in a different world. The first improvement was 
                      introducing 3D films which allowed the audience to actively, and physically, 
                      experience the environment from the screen.
                      <br></br>
                      But, not many know that the first attempt of making cinema more interactive 
                      goes back to 1960 when the film ‘Scent of Mystery’ included a new technology 
                      called ‘Smell-O-Vision’. The new edition released odours and scents to fulfil 
                      the action from the screen. Back then, it was a ridiculous experiment that turned 
                      out to be taken as a joke, but it opened a window to 3D cinema and IMAX as a 
                      pioneering provider of an enhanced cinematic experience.
                      <br></br>
                      IMAX is at the forefront of the latest technological upgrades to cinemas worldwide. 
                      Recently, they partnered up with a director and producer Michael Bay (‘Transformers’), 
                      video game developer Starbreeze and Google to create six ‘virtual reality hubs’ around 
                      the world. Rooted in the cinematic experience, these hubs are expected to incorporate a 
                      stunning cinematography and IMAX’s award-winning vistas.
                      <br></br>
                      If you are a fan of virtual reality and cinema, you should consider going to Amsterdam, 
                      which is a home of the first VR cinema. Opened in early 2016, The VR Cinema does not 
                      resemble a traditional cinema – audience sits in a plain room, without a screen, equipped 
                      only with office-style spinning chairs. Wearing a head-mounted display, participants view 
                      the film entirely in virtual reality.                   
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Virtual Reality Amusement Parks</b>
                    <br></br>
                      Another treat for those who love to escape reality and pretend to 
                      live in a different world. We are all familiar with Disney, Universal 
                      Studios and many others who are behind some of the most well-made animated films.
                      <br></br>
                      They also have one more similarity – they like to invest in their 
                      amusement parks. All of them have been working with a stimulation 
                      technology to enhance the experience even more and create stimulation 
                      rooms such as Star Tours.
                      <br></br>
                      Apart from wearing the visible head-mounted displays, they also have HD 
                      screens, excellent sound system and motorised seats to encourage the 
                      adventure even more.
                      <br></br>
                      Amusement parks have also been focusing on building VR rollercoasters. 
                      Six Flags Virtual Reality Rollercoaster is perhaps the most popular and 
                      has experienced a tremendous success ever since its launch in early 2017. 
                      These rollercoasters still function as the traditional ones, but they also 
                      equipped users with a head-mounted display that transports riders to fantastical 
                      environments in a far more immersive fashion. Some of them feature dragons, 
                      different planets or even give an illusion of other flying objects being around.
                      <br></br>
                      One of the pioneers in this field is VR Coaster who partnered up with 
                      American-based Six Flags amusement parks to add VR into their rollercoasters. 
                      The company uses the Samsung Gear VR mobile-based headsets and gives riders 
                      an entirely different level of entertainment.
                      <br></br>
                      Naturally, China has followed the American trend and created a similar model of 
                      VR rollercoaster – Spaces – worth $30 million in the capital. The former Dreamworks 
                      executives wanted to upgrade already existing amusement parks with VR capabilities 
                      and build new VR centres.
                      <br></br>
                      Virtual Reality-enhanced rollercoaster can not only enhance the riding experience 
                      but also give a genuine sense of speed and wind gusts. Who knows, maybe one day we 
                      won’t even need a physical rollercoaster, and we could get the same experience by 
                      sitting down in our living room with a VR headset.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Virtual Reality and the Adult Industry</b>
                      <br></br>
                        We have reached the most interesting, and controversial, aspect of 
                        virtual reality and entertainment – the adult industry. The truth is, 
                        porn is responsible for the success of many entertainment technologies, 
                        from the rise of VHS tapes to HD television sets.
                        <br></br>
                        Today, it is predicted that by 2025 the VR pornography market will reach $1 
                        billion and overtake the video games regarding a revenue. While it may sound 
                        dubious, the adult industry is well-known for being one of the most lucrative 
                        ones, and it will not change one it incorporates VR.
                        <br></br>
                        The big players in the industry are already releasing 360-degree videos, 
                        remote-operated devices as sex toys, and head-mounted displays that can 
                        imitate a real-life intercourse and humans.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      The entertainment industry has always been one of the first ones to incorporate 
                      any new technologies that will help with bringing more customers on board. While 
                      in some countries, the film industry is about to experience the 3D technology, 
                      most are already looking into what is next.                    
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
{/* -------------- Footer Start -------- */}
                <Row className="mt-5">
                </Row>
                <Row className="pt-5 pb-5 home-background-gray">
                  <Col xs="0" sm="0" lg="1">
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "ml-2 text-left">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>PRODUCT</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                         <a href = "/feature"><div className = "font-size-10" >Features</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/appguide"><div className = "font-size-10" >App Guide</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <div className = "font-size-10" >Platform Guide</div>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "/customdev"><div className = "font-size-10" >Custom Development</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <div className = "font-size-10" >Pricing</div>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "https://goo.gl/1s6PZH" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" >Get VR Headset</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div >USE CASES</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/realestate"><div className = "font-size-10" >Real Estate</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/architecture"><div className = "font-size-10" >Architecture</div></a>
                      </Col>
                      <Col className = "mb-2  text-secondary" md = '12'> 
                        <a href = "/medical"><div className = "font-size-10" >Medical</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/retail"><div className = "font-size-10" >Retail</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/sports"><div className = "font-size-10" >Sports</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/media"><div className = "font-size-10" >Media</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/travel"><div className = "font-size-10" >Travel</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/education"><div className = "font-size-10" >Education</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/training"><div className = "font-size-10" >Training</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/ecommerce"><div className = "font-size-10" >Ecommerce</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/entertainment"><div className = "font-size-10" >Entertainment</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>Support</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "http://www.icomputinglabs.in/blog/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" >Blog</div> </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/faq"><div className = "font-size-10" >FAQ</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/contact"><div className = "font-size-10" >Contact</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>COMPANY</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/about"><div className = "font-size-10" >About</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/privacy"><div className = "font-size-10" >Privacy Policy</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/tos"><div className = "font-size-10" >Terms of Service</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>GET CONNECTED</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.facebook.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-facebook-square fa-lg mr-2" />facebook</div>
                        </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.instagram.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><img  alt="" src={instagram_square} className = "text-primary width-16 mr-2" />instagram</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "https://twitter.com/iComputingLabs" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-twitter-square fa-lg mr-2" />twitter</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'>
                        <a href = "https://www.linkedin.com/company/13404850/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-linkedin-square fa-lg mr-2" />linkedin</div>
                        </a>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              {/* -------------- Footer End -------- */}
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default Entertainment;



// WEBPACK FOOTER //
// ./src/views/Pages/Entertainment/Entertainment.js